// Types mirror the FastAPI Pydantic models. Hand-written for now;
// switching to openapi-typescript codegen is a future option if the surface grows.

export interface TokenResponse {
  access_token: string;
  token_type: "bearer";
  expires_in: number;
}

export interface MessageOut {
  detail: string;
}

export interface MeOut {
  id: number;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  designation?: string | null;
  status: number;
  type: number;
}

export interface UsernameAvailability {
  username: string;
  available: boolean;
  reason?: string | null;
}

export interface LinkOut {
  id: number;
  type: "social" | "about";
  link?: string | null;
  value?: string | null;
  position: number;
}

// Each styling section has identical 4-field shape. The DB columns are
// flattened (e.g. `card_typography`, `vido_bg_color`), so we keep the type
// flat too — easier for the form to bind.
interface AccountFields {
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  web?: string | null;
  address?: string | null;
  designation?: string | null;
}

interface ContentFields {
  profile?: string | null;
  card_logo?: string | null;
  about_text?: string | null;
  video_heading?: string | null;
  about_heading?: string | null;
  video_url?: string | null;
  card_style?: string | null;
}

interface StylingFields {
  // Header / main
  typography?: string | null;
  color_or_img?: string | null;
  bg_color?: string | null;
  bg_image?: string | null;
  bg_repeat?: string | null;
  bg_position?: string | null;
  bg_size?: string | null;
  // Card
  card_typography?: string | null;
  card_color_or_img?: string | null;
  card_bg_color?: string | null;
  card_bg_image?: string | null;
  card_bg_repeat?: string | null;
  card_bg_position?: string | null;
  card_bg_size?: string | null;
  // Video
  vido_typography?: string | null;
  vido_color_or_img?: string | null;
  vido_bg_color?: string | null;
  vido_bg_image?: string | null;
  vido_bg_repeat?: string | null;
  vido_bg_position?: string | null;
  vido_bg_size?: string | null;
  // About
  abt_typography?: string | null;
  abt_color_or_img?: string | null;
  abt_bg_color?: string | null;
  abt_bg_image?: string | null;
  abt_bg_repeat?: string | null;
  abt_bg_position?: string | null;
  abt_bg_size?: string | null;
}

export interface ProfileOut extends AccountFields, ContentFields, StylingFields {
  id: number;
  status: number;
  type: number;
  links: LinkOut[];
}

export interface PublicProfileOut extends Omit<AccountFields, "username">, ContentFields, StylingFields {
  username: string;
  links: LinkOut[];
}

// Mirrors backend ProfileUpdate (Pydantic) — every field optional.
export interface ProfileUpdate extends Partial<AccountFields>, Partial<ContentFields>, Partial<StylingFields> {}

// Two valid section keys for the user_links discriminator.
export type LinkType = "social" | "about";

// The four parallel styling sections in the editor — the column prefix per
// section lets us iterate over them generically rather than writing four
// near-identical forms.
export const STYLING_SECTIONS = [
  { key: "", label: "Header section", num: "02" },
  { key: "card_", label: "Card section", num: "03" },
  { key: "vido_", label: "Video section", num: "04" },
  { key: "abt_", label: "About section", num: "05" },
] as const;

export type StylingSectionPrefix = (typeof STYLING_SECTIONS)[number]["key"];
